import axios from "axios";
import { Markup } from "interweave";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../../../App";
import Dolar from "../../../../../../assets/images/dollarSign.webp";
import Totalitem from "../../../../../../assets/images/Downloads/new-product1.png";
import Product from "../../../../../../assets/images/Downloads/package.png";
import Price from "../../../../../../assets/images/tagPrice.PNG";
import "./MarketEdit.css";

const SuperstarConfirmEditMarketplace = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  let history = useHistory();

  // function handleClick() {
  //     // history.push('/superstar-admin/souvenir/live-biddings');
  //     history.push('/superstar/souvenir/product-list');
  // }

  const { id } = useParams();

  const [title, setTitle] = useState("");
  const [unit_price, setUnitPrice] = useState("");
  const [total_items, setTotalItems] = useState("");
  const [keywords, setKeywords] = useState("");
  const [image, setImage] = useState();
  const [description, setDescription] = useState("");
  const [tax, setTax] = useState("");
  const [showProduct, setShowProduct] = useState({});
  const [delivery_charge, setDeliveryCharge] = useState("");
  const [terms_conditions, setTermsConditions] = useState("");

  useEffect(() => {
    axios.get(`/api/star/marketplace/product-edit/${id}`).then((res) => {
      if (res.data.status === 200) {
        setShowProduct(res.data?.editData);
        setTitle(res.data.editData?.title);
        setUnitPrice(res.data.editData?.unit_price);
        setTotalItems(res.data.editData?.total_items);
        setImage(res.data.editData?.image);
        setKeywords(res.data.editData?.keywords);
        setDescription(res.data.editData?.description);
        setTermsConditions(res.data.editData?.terms_conditions);
        setTax(res.data.editData?.tax);
        setDeliveryCharge(res.data.editData?.delivery_charge);
      }
    });
  }, []);

  // function handleSubmit(e) {
  //     e.preventDefault();
  //   }

  const approvedStarMarketplace = async (e) => {
    e.preventDefault();

    axios.get(`/api/star/marketplace/product-approved/${id}`).then((res) => {
      if (res.data.status === 200) {
          swal("Success!","Product Approved Successfully","success");
          history.push("/superstar/product-list/pending");
      }
    });
  };

  const declineStarMarketplace = async (e) => {
    e.preventDefault();

    axios.get(`/api/star/marketplace/product-decline/${id}`).then((res) => {
      if (res.data.status === 200) {
        swal("Declined!", res.data.message, "success");
        history.push("/superstar/marketplace");
      }
    });
  };

  return (
    <div>
      <div className="row mb-3">


        <div className="col-sm-12 col-md-12 col-lg-6 mb-3">
          <div className="row registration-body  card-bg mx-2 pt-3">
            <div className="col-md-6 mb-3">
              <div className="d-flex registration-btn p-2">
                <div className="mx-3 mt-2">
                  <span className="text-light">
                    <img src={Product} alt="" className="PriceTage" />
                  </span>
                </div>
                <div className=" mx-1">
                  <span className="text-light">Total Items</span>
                  <br></br>
                  <span className=" text-warning fw-bold">
                    {total_items} Pieces
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-3">
              <div className="d-flex registration-btn p-2">
                <div className="mx-3 mt-2">
                  <span className="text-light">
                    <img src={Dolar} alt="" className="PriceTage" />
                  </span>
                </div>
                <div className=" mx-1">
                  <span className="text-light">Unit Price</span>
                  <br></br>
                  <span className=" text-warning fw-bold">{unit_price} $</span>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="d-flex registration-btn p-2">
                <div className="mx-3 mt-2">
                  <span className="text-light">
                    <img src={Dolar} alt="" className="PriceTage" />
                  </span>
                </div>
                <div className=" mx-1">
                  <span className="text-light">Tax</span>
                  <br></br>
                  <span className=" text-warning fw-bold">{tax} %</span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className="col-sm-12 col-md-12 col-lg-6 mb-3">

        <img
            src={imageCdnUrl + image}
            alt="Pineapple"
            className="img-fluid  Cricket-Img"
            style={{ border: "2px solid gold", height: "260px" }}
         />
         </div>
      </div>

      <div className="row mt-1">
        <div className="col-md-12">
          <div className="card card-bg shadow">
            <div className="card-body">
              <h3 className="text-light fw-bolder pb-3">
                <i>{title}</i>
              </h3>

              <h5 className="text-warning">Description</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={description} />
              </p>
              <h5 className="text-warning">Instruction</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={terms_conditions} />
              </p>
            </div>
          </div>
        </div>
      </div>
      {Number(showProduct?.post_status) == 0 ? (
        <div className="mt-3 row">
          <div className="col-md-6 mx-auto row">
            <div className="col-md-6 my-1">
              <button
                onClick={approvedStarMarketplace}
                className="btn btnConfirm w-100 fw-bold px-5 mx-1"
              >
                Approve
              </button>
            </div>
            <div className="col-md-6 my-1">
              <button
                onClick={declineStarMarketplace}
                className="btn btnDecline fw-bold w-100 px-5 mx-1"
              >
                Decline{" "}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SuperstarConfirmEditMarketplace;
